import React from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Notification } from '../../../../../../common/notification'
import { DefaultVsicName } from '../../../DefaultVsicName'
import { IMPORT_EXPORT_TAB } from '../../constant'
import { SourceLabel } from '../../sourceLabel'
import { selectIds } from '../store/slice'
import { ImportExportGrowthRateTable } from './ImportExportGrowthRateTable'
import { ImportExportValueTable } from './ImportExportValueTable'
import { Tab } from './Tab'
import classes from './index.module.scss'

export const ImportExportTableContent = ({ tab, isDynamicReport, column }) => {
  const ids = useSelector(selectIds)

  if (!ids?.length && isDynamicReport) {
    return <Notification isDynamicReport={isDynamicReport} />
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className="flexColumn">
          <Translate
            value="industryOverview.macroeconomics.IMPORT_EXPORT_BALANCE_TRADE"
            className="fw600"
          />
          <DefaultVsicName isDynamicReport={isDynamicReport} />
        </div>
        {!isDynamicReport && <Tab />}
      </div>
      <div className="flex1">
        {tab === IMPORT_EXPORT_TAB.GROWTH_RATE_PERCENT.key ? (
          <ImportExportGrowthRateTable
            isDynamicReport={isDynamicReport}
            column={column}
          />
        ) : (
          <ImportExportValueTable
            isDynamicReport={isDynamicReport}
            column={column}
          />
        )}
      </div>
      <SourceLabel isRight />
    </div>
  )
}
